import { Button, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';

import { LogoFinished } from '@/components/Icon/Logo';
import { Form } from '@/components/Layout/Layout.styled';
import { Page } from '@/components/Layout/Page/Page';

import { useAppDispatch } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import { signOut } from '@/redux/auth/actions';

import { getDataTestId } from '@/utils/browser';

export function JointAdultAgeValidationFailedPage() {
  const { t } = useTranslate();
  const dispatch = useAppDispatch();
  const onBackToSignIn = () => dispatch(signOut());

  return (
    <Page
      paperProps={{
        position: 'right',
        size: 'big',
        hasLogo: false,
        color: (theme: Theme) => theme.palette.overlay.forest.start,
        secondColor: (theme: Theme) => theme.palette.overlay.forest.end,
        children: <LogoFinished />,
      }}
    >
      <Typography
        variant="body2"
        mt={30}
        {...getDataTestId('joint-adult-age-validation-failed-page-body')}
      >
        {t('createNewAccount.jointAdultAgeValidationFailed.body')}
      </Typography>
      <Typography
        variant="body2"
        mt={2}
        {...getDataTestId('joint-adult-age-validation-failed-page-body2')}
      >
        {t('createNewAccount.jointAdultAgeValidationFailed.body2')}
      </Typography>
      <Form>
        <Button
          variant="text"
          onClick={onBackToSignIn}
          {...getDataTestId(
            'joint-adult-age-validation-failed-page-login-button',
          )}
        >
          {t(
            'createNewAccount.jointAdultAgeValidationFailed.button.backToLogin',
          )}
        </Button>
      </Form>
    </Page>
  );
}

export default JointAdultAgeValidationFailedPage;
